// import { IUserState } from "@/store/reducers/user";

export const setRole = (role: any) => {
  return {
    type: 'SET_ROLE',
    role,
  };
};
